import React from 'react';
import { Popover, Typography } from 'antd';
import type { VehicleCargoProjection } from '../../routes/execution/dashboardProjection';

const { Text } = Typography;

type Props = {
  vehicleCargo: VehicleCargoProjection;
};

function inVehicleItems(vehicleCargo: VehicleCargoProjection) {
  return vehicleCargo.items.filter(
    (i) =>
      i.currentState === 'in_transit' ||
      i.currentState === 'partially_unloaded' ||
      i.currentState === 'loading'
  );
}

export const VehicleCargoStrip: React.FC<Props> = ({ vehicleCargo }) => {
  const items = inVehicleItems(vehicleCargo);

  if (items.length === 0) {
    return (
      <div className="execution-workspace__cargo-strip">
        <Text className="execution-workspace__muted">В машине: пусто</Text>
      </div>
    );
  }

  return (
    <section className="execution-workspace__section execution-workspace__section--cargo">
      <div className="execution-workspace__section-title">В машине → куда</div>
      <div className="execution-workspace__cargo-matrix">
        {items.map((item) => (
          <div key={item.cargoId} className="execution-workspace__cargo-row">
            <Popover
              trigger="click"
              title={item.cargoName}
              content={
                <div style={{ maxWidth: 220, fontSize: 12 }}>
                  <div>Статус: {item.stateLabel}</div>
                  <div>Погружено: {item.loadedQty} · Выгружено: {item.unloadedQty}</div>
                  <div>В машине: {item.remainingQty}</div>
                  {item.fromStop ? <div>Откуда: {item.fromStop}</div> : null}
                  {item.applicationNumber ? <div>Заявка №{item.applicationNumber}</div> : null}
                </div>
              }
            >
              <span className="execution-workspace__cargo-chip" role="button" tabIndex={0}>
                {item.cargoName} · {item.remainingQty > 0 ? item.remainingQty : item.loadedQty}
              </span>
            </Popover>
            <span className="execution-workspace__cargo-arrow">→</span>
            <Text className="execution-workspace__cargo-dest">
              {item.toStop ?? '—'}
            </Text>
          </div>
        ))}
      </div>
      <Text className="execution-workspace__muted" style={{ fontSize: 11, marginTop: 4 }}>
        {vehicleCargo.inVehiclePlaces} мест
        {vehicleCargo.inVehicleWeightKg > 0 ? ` · ${vehicleCargo.inVehicleWeightKg} кг` : ''}
      </Text>
    </section>
  );
};

export default VehicleCargoStrip;
